import { Routes as PackageRoutes } from "traffic-property-app/pages/explore/package";
import component from "./details";

const [route] = PackageRoutes;
export const Routes = [{ ...route, component }];
